import { TAB_COUNTS } from '../data/mockBooks';

interface SidebarProps {
  active: string;
  onSelect: (l: string) => void;
}

export function Sidebar({ active, onSelect }: SidebarProps) {
  return (
    <aside
      style={{
        width: 232,
        background: 'var(--a-card)',
        borderRight: '1px solid var(--a-line)',
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 0',
        height: '100vh',
      }}
    >
      <div
        style={{
          padding: '0 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          marginBottom: 28,
        }}
      >
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 8,
            background: 'var(--ink)',
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
            fontFamily: 'var(--serif)',
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          k
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--a-ink)' }}>
            Kuscheltier Buch
          </div>
          <div style={{ fontSize: 10, color: 'var(--a-ink-mute)', fontFamily: 'var(--mono)' }}>
            ADMIN · v0.1.0
          </div>
        </div>
      </div>
      <div style={{ padding: '0 12px' }}>
        <div
          style={{
            fontSize: 10,
            color: 'var(--a-ink-mute)',
            fontWeight: 600,
            letterSpacing: 1.5,
            padding: '0 8px 8px',
            fontFamily: 'var(--mono)',
          }}
        >
          BÜCHER
        </div>
        {TAB_COUNTS.map((t) => {
          const sel = t.l === active;
          return (
            <div
              key={t.l}
              onClick={() => onSelect(t.l)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '7px 10px',
                borderRadius: 6,
                cursor: 'pointer',
                background: sel ? 'var(--a-line-soft)' : 'transparent',
                marginBottom: 1,
              }}
            >
              <span
                style={{
                  fontSize: 13,
                  color: sel ? 'var(--a-ink)' : 'var(--a-ink-soft)',
                  fontWeight: sel ? 600 : 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <span
                  style={{
                    width: 4,
                    height: 4,
                    borderRadius: 999,
                    background: t.c ?? 'var(--a-ink-mute)',
                  }}
                />
                {t.l}
              </span>
              <span
                style={{
                  fontSize: 11,
                  color: 'var(--a-ink-mute)',
                  padding: '1px 6px',
                  background: sel ? 'var(--a-card)' : 'transparent',
                  borderRadius: 4,
                  fontFamily: 'var(--mono)',
                }}
              >
                {t.n}
              </span>
            </div>
          );
        })}
      </div>
      <div
        style={{
          marginTop: 'auto',
          padding: '12px 20px',
          borderTop: '1px solid var(--a-line)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div
            style={{
              width: 28,
              height: 28,
              borderRadius: 999,
              background: 'var(--a-blue-soft)',
              color: 'var(--a-blue)',
              display: 'grid',
              placeItems: 'center',
              fontSize: 11,
              fontWeight: 700,
            }}
          >
            FB
          </div>
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--a-ink)' }}>Operator</div>
            <div style={{ fontSize: 10, color: 'var(--a-ink-mute)' }}>iman@12kmedia.com</div>
          </div>
        </div>
      </div>
    </aside>
  );
}
